export default __webpack_public_path__ + "static/media/plane-ticket-blue.a7602ad1.svg";